// Municípios da Paraíba (223) e sua mesorregião — fonte: IBGE, API de localidades (estado 25).
export const PARAIBA_MESORREGIOES = [
  "Mata Paraibana",
  "Agreste Paraibano",
  "Borborema",
  "Sertão Paraibano",
] as const;

export type Mesorregiao = (typeof PARAIBA_MESORREGIOES)[number];

export const PARAIBA_MUNICIPIOS = [
  "Água Branca",
  "Aguiar",
  "Alagoa Grande",
  "Alagoa Nova",
  "Alagoinha",
  "Alcantil",
  "Algodão de Jandaíra",
  "Alhandra",
  "Amparo",
  "Aparecida",
  "Araçagi",
  "Arara",
  "Araruna",
  "Areia",
  "Areia de Baraúnas",
  "Areial",
  "Aroeiras",
  "Assunção",
  "Baía da Traição",
  "Bananeiras",
  "Baraúna",
  "Barra de Santa Rosa",
  "Barra de Santana",
  "Barra de São Miguel",
  "Bayeux",
  "Belém",
  "Belém do Brejo do Cruz",
  "Bernardino Batista",
  "Boa Ventura",
  "Boa Vista",
  "Bom Jesus",
  "Bom Sucesso",
  "Bonito de Santa Fé",
  "Boqueirão",
  "Borborema",
  "Brejo do Cruz",
  "Brejo dos Santos",
  "Caaporã",
  "Cabaceiras",
  "Cabedelo",
  "Cachoeira dos Índios",
  "Cacimba de Areia",
  "Cacimba de Dentro",
  "Cacimbas",
  "Caiçara",
  "Cajazeiras",
  "Cajazeirinhas",
  "Caldas Brandão",
  "Camalaú",
  "Campina Grande",
  "Capim",
  "Caraúbas",
  "Carrapateira",
  "Casserengue",
  "Catingueira",
  "Catolé do Rocha",
  "Caturité",
  "Conceição",
  "Condado",
  "Conde",
  "Congo",
  "Coremas",
  "Coxixola",
  "Cruz do Espírito Santo",
  "Cubati",
  "Cuité",
  "Cuité de Mamanguape",
  "Cuitegi",
  "Curral de Cima",
  "Curral Velho",
  "Damião",
  "Desterro",
  "Diamante",
  "Dona Inês",
  "Duas Estradas",
  "Emas",
  "Esperança",
  "Fagundes",
  "Frei Martinho",
  "Gado Bravo",
  "Guarabira",
  "Gurinhém",
  "Gurjão",
  "Ibiara",
  "Igaracy",
  "Imaculada",
  "Ingá",
  "Itabaiana",
  "Itaporanga",
  "Itapororoca",
  "Itatuba",
  "Jacaraú",
  "Jericó",
  "João Pessoa",
  "Joca Claudino",
  "Juarez Távora",
  "Juazeirinho",
  "Junco do Seridó",
  "Juripiranga",
  "Juru",
  "Lagoa",
  "Lagoa de Dentro",
  "Lagoa Seca",
  "Lastro",
  "Livramento",
  "Logradouro",
  "Lucena",
  "Mãe d'Água",
  "Malta",
  "Mamanguape",
  "Manaíra",
  "Marcação",
  "Mari",
  "Marizópolis",
  "Massaranduba",
  "Mataraca",
  "Matinhas",
  "Mato Grosso",
  "Maturéia",
  "Mogeiro",
  "Montadas",
  "Monte Horebe",
  "Monteiro",
  "Mulungu",
  "Natuba",
  "Nazarezinho",
  "Nova Floresta",
  "Nova Olinda",
  "Nova Palmeira",
  "Olho d'Água",
  "Olivedos",
  "Ouro Velho",
  "Parari",
  "Passagem",
  "Patos",
  "Paulista",
  "Pedra Branca",
  "Pedra Lavrada",
  "Pedras de Fogo",
  "Pedro Régis",
  "Piancó",
  "Picuí",
  "Pilar",
  "Pilões",
  "Pilõezinhos",
  "Pirpirituba",
  "Pitimbu",
  "Pocinhos",
  "Poço Dantas",
  "Poço de José de Moura",
  "Pombal",
  "Prata",
  "Princesa Isabel",
  "Puxinanã",
  "Queimadas",
  "Quixaba",
  "Remígio",
  "Riachão",
  "Riachão do Bacamarte",
  "Riachão do Poço",
  "Riacho de Santo Antônio",
  "Riacho dos Cavalos",
  "Rio Tinto",
  "Salgadinho",
  "Salgado de São Félix",
  "Santa Cecília",
  "Santa Cruz",
  "Santa Helena",
  "Santa Inês",
  "Santa Luzia",
  "Santa Rita",
  "Santa Teresinha",
  "Santana de Mangueira",
  "Santana dos Garrotes",
  "Santo André",
  "São Bentinho",
  "São Bento",
  "São Domingos",
  "São Domingos do Cariri",
  "São Francisco",
  "São João do Cariri",
  "São João do Rio do Peixe",
  "São João do Tigre",
  "São José da Lagoa Tapada",
  "São José de Caiana",
  "São José de Espinharas",
  "São José de Piranhas",
  "São José de Princesa",
  "São José do Bonfim",
  "São José do Brejo do Cruz",
  "São José do Sabugi",
  "São José dos Cordeiros",
  "São José dos Ramos",
  "São Mamede",
  "São Miguel de Taipu",
  "São Sebastião de Lagoa de Roça",
  "São Sebastião do Umbuzeiro",
  "São Vicente do Seridó",
  "Sapé",
  "Serra Branca",
  "Serra da Raiz",
  "Serra Grande",
  "Serra Redonda",
  "Serraria",
  "Sertãozinho",
  "Sobrado",
  "Solânea",
  "Soledade",
  "Sossêgo",
  "Sousa",
  "Sumé",
  "Tacima",
  "Taperoá",
  "Tavares",
  "Teixeira",
  "Tenório",
  "Triunfo",
  "Uiraúna",
  "Umbuzeiro",
  "Várzea",
  "Vieirópolis",
  "Vista Serrana",
  "Zabelê",
] as const;

export const MUNICIPIO_MESORREGIAO: Record<(typeof PARAIBA_MUNICIPIOS)[number], Mesorregiao> = {
  "Água Branca": "Sertão Paraibano",
  "Aguiar": "Sertão Paraibano",
  "Alagoa Grande": "Agreste Paraibano",
  "Alagoa Nova": "Agreste Paraibano",
  "Alagoinha": "Agreste Paraibano",
  "Alcantil": "Borborema",
  "Algodão de Jandaíra": "Agreste Paraibano",
  "Alhandra": "Mata Paraibana",
  "Amparo": "Borborema",
  "Aparecida": "Sertão Paraibano",
  "Araçagi": "Agreste Paraibano",
  "Arara": "Agreste Paraibano",
  "Araruna": "Agreste Paraibano",
  "Areia": "Agreste Paraibano",
  "Areia de Baraúnas": "Sertão Paraibano",
  "Areial": "Agreste Paraibano",
  "Aroeiras": "Agreste Paraibano",
  "Assunção": "Borborema",
  "Baía da Traição": "Mata Paraibana",
  "Bananeiras": "Agreste Paraibano",
  "Baraúna": "Borborema",
  "Barra de Santa Rosa": "Agreste Paraibano",
  "Barra de Santana": "Borborema",
  "Barra de São Miguel": "Borborema",
  "Bayeux": "Mata Paraibana",
  "Belém": "Agreste Paraibano",
  "Belém do Brejo do Cruz": "Sertão Paraibano",
  "Bernardino Batista": "Sertão Paraibano",
  "Boa Ventura": "Sertão Paraibano",
  "Boa Vista": "Agreste Paraibano",
  "Bom Jesus": "Sertão Paraibano",
  "Bom Sucesso": "Sertão Paraibano",
  "Bonito de Santa Fé": "Sertão Paraibano",
  "Boqueirão": "Borborema",
  "Borborema": "Agreste Paraibano",
  "Brejo do Cruz": "Sertão Paraibano",
  "Brejo dos Santos": "Sertão Paraibano",
  "Caaporã": "Mata Paraibana",
  "Cabaceiras": "Borborema",
  "Cabedelo": "Mata Paraibana",
  "Cachoeira dos Índios": "Sertão Paraibano",
  "Cacimba de Areia": "Sertão Paraibano",
  "Cacimba de Dentro": "Agreste Paraibano",
  "Cacimbas": "Sertão Paraibano",
  "Caiçara": "Agreste Paraibano",
  "Cajazeiras": "Sertão Paraibano",
  "Cajazeirinhas": "Sertão Paraibano",
  "Caldas Brandão": "Agreste Paraibano",
  "Camalaú": "Borborema",
  "Campina Grande": "Agreste Paraibano",
  "Capim": "Mata Paraibana",
  "Caraúbas": "Borborema",
  "Carrapateira": "Sertão Paraibano",
  "Casserengue": "Agreste Paraibano",
  "Catingueira": "Sertão Paraibano",
  "Catolé do Rocha": "Sertão Paraibano",
  "Caturité": "Borborema",
  "Conceição": "Sertão Paraibano",
  "Condado": "Sertão Paraibano",
  "Conde": "Mata Paraibana",
  "Congo": "Borborema",
  "Coremas": "Sertão Paraibano",
  "Coxixola": "Borborema",
  "Cruz do Espírito Santo": "Mata Paraibana",
  "Cubati": "Borborema",
  "Cuité": "Agreste Paraibano",
  "Cuité de Mamanguape": "Mata Paraibana",
  "Cuitegi": "Agreste Paraibano",
  "Curral de Cima": "Mata Paraibana",
  "Curral Velho": "Sertão Paraibano",
  "Damião": "Agreste Paraibano",
  "Desterro": "Sertão Paraibano",
  "Diamante": "Sertão Paraibano",
  "Dona Inês": "Agreste Paraibano",
  "Duas Estradas": "Agreste Paraibano",
  "Emas": "Sertão Paraibano",
  "Esperança": "Agreste Paraibano",
  "Fagundes": "Agreste Paraibano",
  "Frei Martinho": "Borborema",
  "Gado Bravo": "Agreste Paraibano",
  "Guarabira": "Agreste Paraibano",
  "Gurinhém": "Agreste Paraibano",
  "Gurjão": "Borborema",
  "Ibiara": "Sertão Paraibano",
  "Igaracy": "Sertão Paraibano",
  "Imaculada": "Sertão Paraibano",
  "Ingá": "Agreste Paraibano",
  "Itabaiana": "Agreste Paraibano",
  "Itaporanga": "Sertão Paraibano",
  "Itapororoca": "Mata Paraibana",
  "Itatuba": "Agreste Paraibano",
  "Jacaraú": "Mata Paraibana",
  "Jericó": "Sertão Paraibano",
  "João Pessoa": "Mata Paraibana",
  "Joca Claudino": "Sertão Paraibano",
  "Juarez Távora": "Agreste Paraibano",
  "Juazeirinho": "Borborema",
  "Junco do Seridó": "Borborema",
  "Juripiranga": "Mata Paraibana",
  "Juru": "Sertão Paraibano",
  "Lagoa": "Sertão Paraibano",
  "Lagoa de Dentro": "Agreste Paraibano",
  "Lagoa Seca": "Agreste Paraibano",
  "Lastro": "Sertão Paraibano",
  "Livramento": "Borborema",
  "Logradouro": "Agreste Paraibano",
  "Lucena": "Mata Paraibana",
  "Mãe d'Água": "Sertão Paraibano",
  "Malta": "Sertão Paraibano",
  "Mamanguape": "Mata Paraibana",
  "Manaíra": "Sertão Paraibano",
  "Marcação": "Mata Paraibana",
  "Mari": "Mata Paraibana",
  "Marizópolis": "Sertão Paraibano",
  "Massaranduba": "Agreste Paraibano",
  "Mataraca": "Mata Paraibana",
  "Matinhas": "Agreste Paraibano",
  "Mato Grosso": "Sertão Paraibano",
  "Maturéia": "Sertão Paraibano",
  "Mogeiro": "Agreste Paraibano",
  "Montadas": "Agreste Paraibano",
  "Monte Horebe": "Sertão Paraibano",
  "Monteiro": "Borborema",
  "Mulungu": "Agreste Paraibano",
  "Natuba": "Agreste Paraibano",
  "Nazarezinho": "Sertão Paraibano",
  "Nova Floresta": "Agreste Paraibano",
  "Nova Olinda": "Sertão Paraibano",
  "Nova Palmeira": "Borborema",
  "Olho d'Água": "Sertão Paraibano",
  "Olivedos": "Agreste Paraibano",
  "Ouro Velho": "Borborema",
  "Parari": "Borborema",
  "Passagem": "Sertão Paraibano",
  "Patos": "Sertão Paraibano",
  "Paulista": "Sertão Paraibano",
  "Pedra Branca": "Sertão Paraibano",
  "Pedra Lavrada": "Borborema",
  "Pedras de Fogo": "Mata Paraibana",
  "Pedro Régis": "Mata Paraibana",
  "Piancó": "Sertão Paraibano",
  "Picuí": "Borborema",
  "Pilar": "Mata Paraibana",
  "Pilões": "Agreste Paraibano",
  "Pilõezinhos": "Agreste Paraibano",
  "Pirpirituba": "Agreste Paraibano",
  "Pitimbu": "Mata Paraibana",
  "Pocinhos": "Agreste Paraibano",
  "Poço Dantas": "Sertão Paraibano",
  "Poço de José de Moura": "Sertão Paraibano",
  "Pombal": "Sertão Paraibano",
  "Prata": "Borborema",
  "Princesa Isabel": "Sertão Paraibano",
  "Puxinanã": "Agreste Paraibano",
  "Queimadas": "Agreste Paraibano",
  "Quixaba": "Sertão Paraibano",
  "Remígio": "Agreste Paraibano",
  "Riachão": "Agreste Paraibano",
  "Riachão do Bacamarte": "Agreste Paraibano",
  "Riachão do Poço": "Mata Paraibana",
  "Riacho de Santo Antônio": "Borborema",
  "Riacho dos Cavalos": "Sertão Paraibano",
  "Rio Tinto": "Mata Paraibana",
  "Salgadinho": "Borborema",
  "Salgado de São Félix": "Agreste Paraibano",
  "Santa Cecília": "Agreste Paraibano",
  "Santa Cruz": "Sertão Paraibano",
  "Santa Helena": "Sertão Paraibano",
  "Santa Inês": "Sertão Paraibano",
  "Santa Luzia": "Borborema",
  "Santa Rita": "Mata Paraibana",
  "Santa Teresinha": "Sertão Paraibano",
  "Santana de Mangueira": "Sertão Paraibano",
  "Santana dos Garrotes": "Sertão Paraibano",
  "Santo André": "Borborema",
  "São Bentinho": "Sertão Paraibano",
  "São Bento": "Sertão Paraibano",
  "São Domingos": "Sertão Paraibano",
  "São Domingos do Cariri": "Borborema",
  "São Francisco": "Sertão Paraibano",
  "São João do Cariri": "Borborema",
  "São João do Rio do Peixe": "Sertão Paraibano",
  "São João do Tigre": "Borborema",
  "São José da Lagoa Tapada": "Sertão Paraibano",
  "São José de Caiana": "Sertão Paraibano",
  "São José de Espinharas": "Sertão Paraibano",
  "São José de Piranhas": "Sertão Paraibano",
  "São José de Princesa": "Sertão Paraibano",
  "São José do Bonfim": "Sertão Paraibano",
  "São José do Brejo do Cruz": "Sertão Paraibano",
  "São José do Sabugi": "Borborema",
  "São José dos Cordeiros": "Borborema",
  "São José dos Ramos": "Mata Paraibana",
  "São Mamede": "Borborema",
  "São Miguel de Taipu": "Mata Paraibana",
  "São Sebastião de Lagoa de Roça": "Agreste Paraibano",
  "São Sebastião do Umbuzeiro": "Borborema",
  "São Vicente do Seridó": "Borborema",
  "Sapé": "Mata Paraibana",
  "Serra Branca": "Borborema",
  "Serra da Raiz": "Agreste Paraibano",
  "Serra Grande": "Sertão Paraibano",
  "Serra Redonda": "Agreste Paraibano",
  "Serraria": "Agreste Paraibano",
  "Sertãozinho": "Agreste Paraibano",
  "Sobrado": "Mata Paraibana",
  "Solânea": "Agreste Paraibano",
  "Soledade": "Agreste Paraibano",
  "Sossêgo": "Agreste Paraibano",
  "Sousa": "Sertão Paraibano",
  "Sumé": "Borborema",
  "Tacima": "Agreste Paraibano",
  "Taperoá": "Borborema",
  "Tavares": "Sertão Paraibano",
  "Teixeira": "Sertão Paraibano",
  "Tenório": "Borborema",
  "Triunfo": "Sertão Paraibano",
  "Uiraúna": "Sertão Paraibano",
  "Umbuzeiro": "Agreste Paraibano",
  "Várzea": "Borborema",
  "Vieirópolis": "Sertão Paraibano",
  "Vista Serrana": "Sertão Paraibano",
  "Zabelê": "Borborema",
};
